import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home.component';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [{ path: '', component: HomeComponent, canActivate: [MsalGuard] }];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class HomeRoutingModule {}
